// Polkujen päällekkäisyys-tarkistus. Duplikoitu shared/src/paths/overlap.ts:sta
// koska apps/web on staattinen Vite-build joka ei resolvoi workspace-paketteja
// runtime:lla. Sama logiikka — pidä molemmat synkronoidusti.

export function normalizePath(p: string): string {
  return p.replace(/\/+$/, "");
}

export function pathsOverlap(a: string, b: string): boolean {
  const na = normalizePath(a);
  const nb = normalizePath(b);
  if (na === nb) return true;
  return na.startsWith(nb + "/") || nb.startsWith(na + "/");
}

export function findOverlap(paths: string[]): [string, string] | null {
  for (let i = 0; i < paths.length; i++) {
    for (let j = i + 1; j < paths.length; j++) {
      if (pathsOverlap(paths[i]!, paths[j]!)) {
        return [paths[i]!, paths[j]!];
      }
    }
  }
  return null;
}
